import { graphql } from 'react-relay/legacy';

/**
 * Added item to initial query to be able to pull
 * handlePdpStatuses_item on server to determine if we need to redirect or 404.
 * Do not add other framments to item in this query
 */

export const pdpRespRootQuery = graphql`
    query pdpRespRootQuery(
        $isClient: Boolean!
        $itemId: String!
        $itemIds: [String]!
        $userId: String = ""
        $userIds: [String]
        $fetchUser: Boolean!
        $followSearchPages: [String]
        $fetchFollowSearch: Boolean!
        $isTrade: Boolean!
        $isMultiSku: Boolean!
        $fetchPdp: Boolean!
        $forcedCurrency: Currency
        $userZipCode: String = ""
        $userCountryCode: String = ""
        $priceBookName: String = ""
        $localRecentHistoryItemIds: [String] = []
        $fetchUserRecentHistoryItem: Boolean = false
        $isInteractivePdpChat: Boolean = false
        $timezoneOffset: Int
        $fetchAuction: Boolean = false
        $clickabilityRerankDocs: Int = null
        $clickabilityRerankQueryTemplate: RerankQueryTemplate = null
        $clickabilityVariant: ClickabilityVariant = null
        # VERTICALS-1194: resp PDP redesign test
        $isPdpRedesignVariant: Boolean = false
        $currency: Currency
        $itemQuantity: Int
        # TOF-419: Add personalization module
        $personalizationModuleEnabled: Boolean = false
        # TOF-471: Restyle PDP product tiles
        $hasRestyledProductTiles: Boolean = false
    ) {
        viewer {
            ...PdpRespLayout_viewer
            itemRead(itemIds: $itemIds) {
                ... on Item {
                    isSold
                    isFurniture
                    ...handlePdpStatuses_item
                }
                ...findPdpItemReadError_itemRead
            }
        }
    }
`;

export const pdpRespVariables = {
    isClient: false,
    itemId: null,
    itemIds: [],
    selectedItemIds: [],
    userId: '',
    userIds: [],
    fetchUser: false,
    loadPortfolioData: false,
    followSearchPages: null,
    fetchFollowSearch: false,
    isTrade: false,
    isMultiSku: false,
    fetchPdp: true,
    forcedCurrency: null,
};
